
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career-accelerators/[[...slug]]",
      function () {
        return require("private-next-pages/career-accelerators/[[...slug]].page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career-accelerators/[[...slug]]"])
      });
    }
  